import { I18n } from 'aws-amplify';

I18n.setLanguage('en');
const dict = {
     'en': {
         'Username': 'Email',
         'Enter your Username': 'Enter your email'
      }
}
I18n.putVocabularies(dict);